import { publicApiHeaders } from './publicApiAuth';
import {
  createVideoUrlCryptoContext,
  decryptVideoUrlsInResponse,
} from './videoUrlCrypto';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
const VIDEO_CONTENT_PATHS = new Set(['courses', 'course-details', 'course-videos', 'stories']);

async function getContent(path, params = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  ).toString();
  const videoCrypto = VIDEO_CONTENT_PATHS.has(path)
    ? await createVideoUrlCryptoContext()
    : null;
  const response = await fetch(`${API_BASE_URL}/content/${path}${query ? `?${query}` : ''}`, {
    headers: {
      ...publicApiHeaders,
      ...(videoCrypto?.headers || {}),
    },
  });

  if (!response.ok) {
    throw new Error(`Unable to load ${path}`);
  }

  const data = await response.json();
  return videoCrypto
    ? decryptVideoUrlsInResponse(data, videoCrypto.clientPrivateKey)
    : data;
}

export const unlockFreeResource = async (resourceId) => {
  const response = await fetch(
    `${API_BASE_URL}/user/auth/free-resources/download`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...publicApiHeaders,
        Authorization: `Bearer ${localStorage.getItem('cd_user_token') || ''}`,
      },
      body: JSON.stringify({
        resourceId,
      }),
    },
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.status === false) {
    throw new Error(
      data.message || data.success || 'Unable to record resource download.',
    );
  }

  return data;
};



export const getCourses = (params) => getContent('courses', params);
export const getCourseDetails = (course, byTitle = false) => getContent(
  'course-details',
  byTitle ? { course } : { courseId: course },
);
export const getCourseVideos = (course, byTitle = false) => getContent(
  'course-videos',
  byTitle ? { course } : { courseId: course },
);
export const getBlogs = (params) => getContent('blogs', params);
export const getFaqs = (params) => getContent('faqs', params);
export const getStories = (params) => getContent('stories', params);
export const getCourseCategories = () => getContent('course-categories');
export const getBlogCategories = () => getContent('blog-categories');
export const getStoryCategories = () => getContent('story-categories');
export const getFeedbacks = () => getContent('feedbacks');
export const getEvents = () => getContent('events');
export const getWhyChoose = () => getContent('why-choose');
export const getMentor = () => getContent('mentor');
export const getTrustedBy = () => getContent('trusted-by');
export const getHero = () => getContent('hero');
